// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__2uSen","info":"Alert_info__3gT39","danger":"Alert_danger__1E-ir","success":"Alert_success__upIVj"};